export function apiUrl(path) {
	const base = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '');
	return `${base}${path.startsWith('/') ? '' : '/'}${path}`;
}

/**
 * Normalizes an API Platform collection response into a plain array.
 * Handles: plain array, hydra:member wrapper, or member wrapper (hydra_prefix: false).
 */
export function extractCollection(data) {
	if (Array.isArray(data)) return data;
	if (data && typeof data === 'object') {
		if (Array.isArray(data['hydra:member'])) return data['hydra:member'];
		if (Array.isArray(data.member)) return data.member;
	}
	return [];
}
